import { Userdata } from "@/types/user";
import { useGetAuthenticatedUserQuery } from "@/api/authentication";

export const emptyUserData: Userdata = {
  organization: {
    name: "",
    id: "",
    features: [],
  },
  features: [],
  avatar: "",
  id: "",
  name: "",
  username: "",
  email: "",
  phoneNumber: "",
  surname: "",
  isActive: false,
};

interface AuthenticatedUser extends Userdata {
  isAuthenticated: boolean;
}

export const useAuthenticatedUser = (): AuthenticatedUser => {
  const { data: userData = emptyUserData, isError } = useGetAuthenticatedUserQuery();

  return { ...userData, isAuthenticated: isError ? false : !!userData.id };
};
